import React, { useState, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchDefinedProcessLoss } from "../../../redux/processLossSlice";
import { useNavigate } from "react-router-dom";

const DefinedLoss = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /********************************* State Management *********************************/

  const [processLossType, setProcessLossType] = useState("defined");

  /********************************* Functions  Fetch State Varibles from Store *********************************/

  const viewData = useSelector((state) => state.processLoss?.definedProcessLossInfo || {});

  /********************************* Use Effect *********************************/
  useEffect(() => {
    const queryParams = {
      type: processLossType
    };
    dispatch(fetchDefinedProcessLoss(queryParams));
  }, [dispatch]);

  /********************************* Function calls *********************************/

  const editProcessLoss = (flag) => {
    navigate(`/edit-special-plan`);
  };

  /********************************* UI Components *********************************/

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div>
          <h1 className="heading1">Review Process Loss </h1>
          <h5 className="heading2">Review carefully Process Loss </h5>
        </div>
        <div>
          <h5 className="navPageIfo">
            Home / <span style={{ color: " #C8C7C9" }}>Process Loss</span>
          </h5>
        </div>
      </div>
      <div>
        <div className="card mt-3 bg-stage">
          <div className="card-body">
            <div>
              <p className="heading3">Edit Details</p>
              <button
                className="editIcon"
                onClick={() => editProcessLoss("edit")}
              >
                <img src={editIcon} alt="Edit" />
              </button>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="d-flex justify-content-between indect">
                  <div className="left-box w-100 border-end pe-2">
                    <p className="font-13 mb-0">{t("reviewdefineloss.spinning")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[0]?.process_loss)}%</div>
                  </div>
                  <div className="ps-2 right-box w-100">
                    <p className="font-13 mb-0">{t("reviewdefineloss.knitting")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[1]?.process_loss)}%</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex justify-content-between indect">
                  <div className="left-box w-100 border-end pe-2">
                    <p className="font-13 mb-0">{t("reviewdefineloss.processing")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[2]?.process_loss)}%</div>
                  </div>
                  <div className="ps-2 right-box w-100">
                    <p className="font-13 mb-0">{t("reviewdefineloss.designing")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[3]?.process_loss)}%</div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex justify-content-between indect">
                  <div className="left-box w-100 border-end pe-2">
                    <p className="font-13 mb-0">{t("reviewdefineloss.flat-knitting")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[5]?.process_loss)}%</div>
                  </div>
                  <div className="ps-2 right-box w-100">
                    <p className="font-13 mb-0">{t("reviewdefineloss.yarn-dyeing")} %</p>
                    <div className="bg-slash font-14">{Math.floor(viewData[6]?.process_loss)}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefinedLoss;
